import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  makeStyles,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { formatCurrencyPesos } from "../../../helpers/extraFunctions";

const useStyles = makeStyles({
  cell: {
    paddingLeft: '2%'
  },
});

export const ModalInformacionPago = (props) => {
  const classes = useStyles();

  const pagos = props.items;
  const [page] = useState(0);
  const [rowsPerPage] = useState(5);
  const [dense, setDense] = useState(true);

  return (
    <Dialog fullWidth maxWidth="md" open={props.open} >
      <DialogTitle>
        Detalle de Pagos - IdSolicitud: {`${props.idSolicitud}`}
      </DialogTitle>
      <DialogContent >
        {Array.isArray(pagos) &&
          pagos?.length > 0 ? (
          <TableContainer component={Paper} style={{ overflowX: "auto"}}>
            <Table size={dense ? "small" : "medium"} >
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "10%"}} className={classes.cell}>Cantidad</TableCell>
                  <TableCell style={{ width: "13%"}} className={classes.cell}>Codigo Nomenclador</TableCell>
                  <TableCell style={{ width: "25%"}} className={classes.cell}>Descripción</TableCell>   
                  <TableCell style={{ width: "12%"}} className={classes.cell}>Importe Práctica</TableCell>               
                  <TableCell style={{ width: "8%"}} className={classes.cell}>Nro. Lote</TableCell>
                  <TableCell style={{ width: "10%"}} className={classes.cell}>Nro. Cupon</TableCell>
                  <TableCell style={{ width: "8%"}} className={classes.cell}>Medio Pago</TableCell>
                  <TableCell style={{ width: "12%"}} className={classes.cell}>Importe Cupon</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pagos
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => {
                    return (
                      <TableRow key={item.periodo}>
                        <TableCell className={classes.cell}>{item.cant}</TableCell>
                        <TableCell className={classes.cell}>{item.practica?.codNom}</TableCell>
                        <TableCell className={classes.cell}>{item.practica?.desNom}</TableCell>
                        <TableCell className={classes.cell}>
                          {formatCurrencyPesos(item.importeCoseguro)}
                        </TableCell>
                        <TableCell className={classes.cell}>{item.nroLote}</TableCell>
                        <TableCell className={classes.cell}>{item.nroCupon}</TableCell>
                        <TableCell className={classes.cell}>{item.pagoCoseguro?.medioPago?.descripcion}</TableCell>
                        <TableCell className={classes.cell} style={{paddingRight: '2%'}}>
                          {formatCurrencyPesos(item.pagoCoseguro?.importeCupon)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography style={{ fontStyle: "italic", fontSize: "1.1rem", textAlign: 'center', marginBottom: 15}}>
            No hay pagos registrados
          </Typography>
        )}
        
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: pagos?.length > 0 ? "space-between" : "right",
              margin: "1.5rem 0",
            }}
          >
            {pagos?.length > 0 && (
              <FormControlLabel
                style={{ marginTop: 20 }}
                control={
                  <Switch
                    checked={dense}
                    onChange={(e) => setDense(e.target.checked)}
                  />
                }
                label="Tamaño compacto"
              />
            )}
            <div>
              <Button
                style={{ margin: "0 1rem", marginTop: 20 }}
                color="secondary"
                variant="contained"
                onClick={props.closeModalHandler}
              >
                Cerrar
              </Button>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
